import type { RouteType } from '~/types/router'

// 考试过程是从"我的考试"按钮进入的业务页面，作为独立全屏页面不嵌套在 Layout 中。
export default {
  name: 'examProcess',
  path: '/exam/process/:recordId',
  component: () => import('./index.vue'),
  isHidden: true,
  meta: {
    title: '考试过程',
    requireAuth: false,
  },
} as RouteType
